type SoundKind = "page" | "rating";

type AudioWindow = Window & typeof globalThis & {
  webkitAudioContext?: typeof AudioContext;
};

let audioContext: AudioContext | null = null;

export async function playUiSound(kind: SoundKind): Promise<void> {
  try {
    const AudioContextConstructor = window.AudioContext
      ?? (window as AudioWindow).webkitAudioContext;
    if (!AudioContextConstructor) return;
    audioContext ??= new AudioContextConstructor();
    if (audioContext.state === "suspended") await audioContext.resume();
    const now = audioContext.currentTime;
    if (kind === "rating") {
      playTone(audioContext, now, 720, 980, 0.055, 0.035, "sine");
      return;
    }
    playTone(audioContext, now, 1_350, 760, 0.026, 0.028, "square");
    playTone(audioContext, now + 0.038, 920, 520, 0.032, 0.022, "triangle");
  } catch {
    // Sound is optional feedback. Browser/device audio restrictions must not block the action.
  }
}

function playTone(
  context: AudioContext,
  startsAt: number,
  startFrequency: number,
  endFrequency: number,
  duration: number,
  volume: number,
  type: OscillatorType,
): void {
  const oscillator = context.createOscillator();
  const gain = context.createGain();
  oscillator.type = type;
  oscillator.frequency.setValueAtTime(startFrequency, startsAt);
  oscillator.frequency.exponentialRampToValueAtTime(endFrequency, startsAt + duration);
  gain.gain.setValueAtTime(volume, startsAt);
  gain.gain.exponentialRampToValueAtTime(0.0001, startsAt + duration);
  oscillator.connect(gain);
  gain.connect(context.destination);
  oscillator.start(startsAt);
  oscillator.stop(startsAt + duration);
}
